import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function About() {
    return (

        <>
            <Header></Header>
            <section className="about" id="go-about">

                <h1 className="abt">about us</h1>

                <h1 className="comp-head"> company introduction</h1>

                <p className="comp-cont">HEXATECH Mechanical Seals, LLP established in 2017.<b>ABDULHANNAN KHORAJIYA</b> AND <b>JUNED MAKNOJIYA</b> IS A FOUNDER,With over 10 years of design and production experiences in mechanical seal component industry.</p>


                <img src="./images/hexa-company.png" alt="company" className="comp-img"></img>

                <p className="comp-info">HEXATECH has become a professional mechanical seal supplier that owns a full set of the chain of product design and development, manufacturing, sales and after-sales support services. Right now HEXATECH Seals is one of the leading mechanical seal manufacturers in INDIA (MUMBAI).</p>

                <p className="comp-info">With continuous innovations, HEXATECH Seals has accomplished a lot of honor and awards As one of the leading high quality mechanical seal suppliers, the company right now has over 10000 square feet of production facilities, 10 main production lines with over 25 full-time employees in the factory Currently HEXATECH Seals is building up its new production facility of 50,000 square meters IN Gujarat.
                    We understand the importance of putting clients on the right path for mechanical seal solutions and we stand ready to work with them
                    HEXATECH supplies different kinds of products with high quality and favorable price. We're pleased to get your inquiry and we will reply you as soon as possible. We stick to the principle of "quality and service come first, with continuous improvement and innovation to meet the customers' requirements" for the management and "zero defect and complaint" as the quality objective.
                    Our seal products have been widely used in different sorts of pumps, including but not limited to chemical pumps, centrifugal pumps, high-temperature oil pumps, clean water pumps, circulating pumps, vacuum pumps, sewage pumps and slurry pumps. Beside for pumps, our seals also work with reaction kettles, submerged motors, compressors, blowers, paper-making equipment, sewage treatment equipment and other rotating machines.
                </p>

                <p className="comp-info">Some products of HEXATECH have become good alternative solutions, which have the same level of quality but more affordable prices, compared to the original seal products from famous industrial companies such as ALFA-LAVAL, Andritz, KSB, John Crane, Grundfos, Siemens, EAGLE, Flexbox, EG&G SEAL OL, Rotan, Sundyne, Chesterton, Pillar and etc.</p>

                <h3 className="comp-info">Why work with us</h3>

                <li className="comp-info">Mechanical Seals: over 3,600 types of mechanical seals designed and manufactured.</li>
                <li className="comp-info">Management System Certification: ISO9001:2015, Certificated.</li>
                <li className="comp-info">Main Products: Agitator Seal, Pump Seal, Mechanical Seal, Rubber Bellow Seal, Metal Bellow Seal, Spring Seal, , Oil Seal, etc.</li>

                <img src="./images/machine.png" className="mac" alt="machine"></img>

                <h3 className="certi-head">company certificate</h3>

                <img src="./images/certificate.jpg" alt="certificate" className="certificate"></img>
            </section>

            <Footer></Footer>
        </>

    );
};

export default About